import React from 'react';
import { Modal, Tooltip, OverlayTrigger } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { scroller } from 'react-scroll';
import classNames from 'classnames';
import uuid from 'uuid';

import DeleteEverything from '../_global/DeleteEverything.jsx';
import api from '../../utils/api';

import '../../styles/projects/Setup.css';
import BillingInfoModal from "../_global/BillingInfoModal";

const paymentTooltip = (
    <Tooltip id="payment-tooltip">
        Set up your billing info above to select
    </Tooltip>
);

const proTooltip = (
    <Tooltip id="pro-tooltip">
        Only available with the Professional plan
    </Tooltip>
);

const granularTooltip = (
    <Tooltip id="granular-tooltip">
        Only available with the Moderation Plus Add-on
    </Tooltip>
);

const verifiedTooltip = (
    <Tooltip id="verified-tooltip">
        Please verify your email address first
    </Tooltip>
);

function FakeOverlay(props) {

    return (<div>{props.children}</div>);
}


export class Setup extends React.Component {

    static defaultProps = {
        project: {},
        notificationSettings: {
            notifyApproved: false,
            notifyPending: false,
            notifyFlagged: false
        },
        approvalProcessOptions: [
            {
                value: 'manual',
                title: 'Manual',
                desc: 'All comments must be manually approved'
            },
            {
                value: 'automatic',
                title: 'Automatic',
                desc: 'All comments are automatically approved'
            },
            {
                value: 'granular',
                title: 'Granular',
                desc: 'All comments are automatically approved, except those:'
            },
        ],
        approvalProcessGranularOptions: [
            {
                value: 'with-links',
                desc: 'containing links'
            },
            {
                value: 'blocked-authors',
                desc: 'from authors blocked on other websites'
            },
            {
                value: 'previously-removed',
                desc: 'from authors with previously removed comments'
            },
            {
                value: 'anonymous',
                desc: 'from anonymous authors'
            },
            {
                value: 'previous-spam',
                desc: 'matching previously removed comments'
            }
        ],
    };

    apiCall = null;

    state = Object.assign({
        id: null,
        name: '',
        domain: '',
        flagThreshold: 2,
        notifyApproved: true,
        notifyPending: true,
        notifyFlagged: true,
        showPaymentMethod: false,
        pricingPlan: 'personal',
        professionalPlan: '',
        moderationPlus: false,
        pricingPlanHover: null,
        approvalProcess: 'automatic',
        approvalProcessGranular: [],
        moderatorEmails: [],
        slackUrl: '',
        slackNotifyApproved: false,
        slackNotifyPending: false,
        slackNotifyFlagged: false,
        webhook: '',
        errors: null,
        errorMessage: '',
        webhookCredentialsAreShowing: false,
        singleSignOnCredentialsAreShowing: false,
        confirmationIsShowing: false,
        deleteProjectIsShowing: false,
        downgradeIsShowing: null

    }, this.props.project, this.props.notificationSettings, { idempotency: uuid.v4() });

    componentDidMount() {

        window.scrollTo(0, 0);

        const isMod = this.props.project.id && this.props.project.userId !== this.props.user.uid;

        const titles = isMod ? [
            {
                id: 'moderation',
                title: 'Moderation'
            }
        ] : [
            {
                id: 'basic-info',
                title: 'Basic Info'
            },
            {
                id: 'pricing-plan',
                title: 'Pricing Plan'
            },
            {
                id: 'moderation-rules',
                title: 'Moderation Rules'
            },
            {
                id: 'extra-moderators',
                title: 'Extra Moderators'
            },
            {
                id: 'webhooks',
                title: 'Webhooks'
            },
            {
                id: 'single-sign-on',
                title: 'Single Sign-On'
            },
            {
                id: 'save-project',
                title: this.props.project.id ? 'Update' : 'Create'
            }
        ];

        if (!titles.find(({ id }) => id === this.props.subcategory)) {
            this.props.onChangeSubcategory(titles[0].id);
        }

        this.props.onChangeSubcategoryTitles(titles);
    }

    componentWillUnmount() {

        api.cancel(this.apiCall);
    }

    onSubmit = e => {

        e.preventDefault();

        const { changeProjects, project: { id } } = this.props;
        const errors = this.formIsValid();

        if (!errors) {

            let p = Promise.resolve();
            if (
                this.props.project.id
                && this.props.project.moderationPlus
                && !this.state.moderationPlus) {
                p = new Promise((resolve, reject) => {

                    this.setState({
                        downgradeIsShowing: { resolve, reject }
                    });
                });
            }

            return p
                .then(() => {

                    this.props.changeCover(true, () => {

                        this.apiCall = api.saveProject({
                            id,
                            name: this.state.name,
                            domain: this.state.domain,
                            flagThreshold: this.state.flagThreshold,
                            notifyApproved: this.state.notifyApproved,
                            notifyPending: this.state.notifyPending,
                            notifyFlagged: this.state.notifyFlagged,
                            pricingPlan: this.state.pricingPlan,
                            moderationPlus: this.state.moderationPlus,
                            approvalProcess: this.state.approvalProcess,
                            approvalProcessGranular: this.state.approvalProcessGranular,
                            moderatorEmails: this.state.moderatorEmails.filter(email => email.length > 0),
                            slackUrl: this.state.slackUrl,
                            slackNotifyApproved: this.state.slackNotifyApproved,
                            slackNotifyPending: this.state.slackNotifyPending,
                            slackNotifyFlagged: this.state.slackNotifyFlagged,
                            webhook: this.state.webhook,
                            idempotency: this.state.idempotency,
                            version: 3

                        }).then(({ data: project }) => {

                            return changeProjects(projects => {

                                return [project].concat(projects.filter(oldProject => oldProject.id !== project.id))

                            }).then(() => {

                                this.setState(Object.assign({}, this.state, project, {
                                    confirmationIsShowing: true,
                                    idempotency: uuid.v4()
                                }), () => {

                                    this.props.changeCover(false);
                                });
                            });

                        }).catch(err => {

                            this.props.changeCover(false, () => {

                                if (err.code === 'invalid-argument') {

                                    this.setState({
                                        errors: err.details
                                    });
                                }
                            });
                        });
                    });

                }).catch(() => {

                });
        }

        if (errors.name || errors.domain || errors.flagThreshold) {

            scroller.scrollTo('basic-info', {
                duration: 500,
                smooth: true,
                offset: -50,
            });
        }

        if (errors.moderatorEmails) {

            scroller.scrollTo('moderator-emails', {
                duration: 500,
                smooth: true,
                offset: -50,
            });
        }
    };

    formIsValid =() => {

        const project = this.state;
        const errors = {};
        let { notificationsAreShowing } = this.state;

        if (!project.name) {
            errors.name = 'A name is required.';
        }
        if (!project.domain) {
            errors.domain = 'A domain is required.';
        }

        if (!Number.isFinite(project.flagThreshold) || project.flagThreshold < 0 || project.flagThreshold > 999) {
            errors.flagThreshold = 'Only numbers between 0 and 999 are accepted.';
        }

        project.moderatorEmails.forEach(email => {

            if (!email.length) {
                return;
            }

            const pieces = email.split('@');
            if (pieces.length !== 2 || pieces[0].length === 0 || pieces[1].length === 0) {
                errors.moderatorEmails = 'Invalid email.';
            }

            if (this.props.project.blockedBy && this.props.project.blockedBy.indexOf(email.toLowerCase().trim()) !== -1) {

                errors.moderatorEmails = `${email} has blocked your moderation requests.`;
            }

        });

        if (project.slackUrl && !project.slackUrl.startsWith('https://')) {

            errors.slackUrl = 'Provided Slack URL is not valid.';
            notificationsAreShowing = true;
        }
        if (project.webhook && !project.webhook.startsWith('https://')) {

            errors.webhook = 'Provided Events Webhook URL is not secure.';
            notificationsAreShowing = true;
        }

        const hasError = Object.keys(errors).length > 0;

        this.setState({
            notificationsAreShowing,
            errors: hasError ? errors : null,
        });

        return hasError ? errors : null;
    };

    validateAfterInvalid = () => {

        if (this.state.errors) {
            this.formIsValid();
        }
    };

    onChangeName = ({ currentTarget: { value: name } }) => {

        this.setState({ name }, this.validateAfterInvalid);
    };

    onChangeDomain = ({ currentTarget: { value: domain } }) => {

        this.setState({ domain }, this.validateAfterInvalid);
    };

    onBlurDomain = ({ currentTarget: { value: domain } }) => {
        try {
            if (domain.startsWith('http')) {
                const url = document.createElement('a');
                url.href = domain;
                return this.setState({ domain: url.hostname });
            }
            const url = document.createElement('a');
            url.href = `https://${domain}`;
            this.setState({ domain: url.hostname });
        } catch (err) {

        }
    }

    onChangeFlagThreshold = ({ currentTarget: { value: flagThreshold } }) => {

        this.setState({ flagThreshold:  parseInt(flagThreshold.slice(0, 3)) }, this.validateAfterInvalid);
    };

    onChangeNotify = ({ currentTarget: { value, checked } }) => {

        this.setState({ [value]: checked });
    };

    onChangePricingPlan = ({ currentTarget: { value: pricingPlan } }) => {

        if (pricingPlan === 'professional') {
            pricingPlan = this.state.professionalPlan || 'professional-monthly';
        }

        this.setState({ pricingPlan });
    };

    onChangeProfessionalPlan = ({ currentTarget: { value: professionalPlan } }) => {

        const state = { professionalPlan };

        if (this.state.pricingPlan !== 'personal') {
            state.pricingPlan = professionalPlan;
        }

        this.setState(state);
    };

    onChangeModerationPlus = ({ currentTarget: { value: override } }) => {

        const state = {
            moderationPlus: !this.state.moderationPlus
        };

        if (override) {
            state.moderationPlus = true;
        }

        if (!state.moderationPlus && this.state.approvalProcess === 'granular') {

            state.approvalProcess = 'automatic';

            if (this.state.approvalProcessGranular.length !== 0) {
                state.approvalProcessGranular = [];
            }
        }


        this.setState(state);
    };

    onTogglePaymentMethodModal = e => {

        this.setState({ showPaymentMethod: !this.state.showPaymentMethod });
    };

    onChangePricingPlanHoverFactory = pricingPlanHover => {

        return () => {
            this.setState({ pricingPlanHover });
        };
    };

    onChangeModeratorEmailFactory = index => {

        return ({ currentTarget: { value } }) => {

            this.setState({
                moderatorEmails: this.state.moderatorEmails.map((email, i) => {

                    if (i === index) {
                        return value;
                    }
                    return email;
                })
            });
        };
    };

    onAddModeratorEmail = e => {

        this.setState({
            moderatorEmails: this.state.moderatorEmails.concat('')
        });
    };

    onRemoveModeratorEmail = ({ currentTarget: { value } }) => {

        const index = Number(value);

        this.setState({
            moderatorEmails: this.state.moderatorEmails.filter((email, i) => {

                return i !== index;
            })
        });
    };

    onChangeApprovalProcess = ({ currentTarget: { value: approvalProcess } }) => {

        this.setState({ approvalProcess, approvalProcessGranular: [] });
    };

    onChangeApprovalProcessGranular = ({ currentTarget: { value: option, checked } }) => {

        const state = { approvalProcess: 'granular' };

        if (checked && (this.state.approvalProcessGranular.indexOf(option) === -1)) {

            state.approvalProcessGranular = [option].concat(this.state.approvalProcessGranular);

        } else if (!checked) {

            state.approvalProcessGranular = this.state.approvalProcessGranular.filter(o => o !== option);
        }

        return this.setState(state);
    };


    onChangeSlackUrl = ({ currentTarget: { value: slackUrl } }) => {

        this.setState({ slackUrl }, this.validateAfterInvalid);
    };

    onChangeWebhook = ({ currentTarget: { value: webhook } }) => {

        this.setState({ webhook }, this.validateAfterInvalid);
    };

    onHideDowngrade = ({ currentTarget: { value } }) => {

        this.state.downgradeIsShowing[value]();

        this.setState({ downgradeIsShowing: null });
    };


    onToggleWebhookCredentials = e => {

        this.setState({ webhookCredentialsAreShowing: !this.state.webhookCredentialsAreShowing });
    };

    onToggleSingleSignOnCredentials = e => {

        this.setState({ singleSignOnCredentialsAreShowing: !this.state.singleSignOnCredentialsAreShowing });
    };

    onHideConfirmation = e => {

        this.setState({ confirmationIsShowing: false }, () => {

            this.props.goToProjectSetup(this.state.id);
        });
    };

    onShowDeleteProject = e => {

        this.setState({ deleteProjectIsShowing: true });
    };

    onHideDeleteProject = e => {

        this.setState({ deleteProjectIsShowing: false });
    };

    onDeleteProject = () => {

        this.apiCall = api.removeProject({ projectId: this.state.id })
            .then(() => {

                return this.props.changeProjects(projects => projects.filter(project => project.id !== this.state.id));
            });

        return this.apiCall;
    };

    onUpdateModeratorSettings = e => {

        this.props.changeModeratorRequestOptions({
            [`${this.props.project.id}/accept/notifyApproved`]: this.state.notifyApproved,
            [`${this.props.project.id}/accept/notifyPending`]: this.state.notifyPending,
            [`${this.props.project.id}/accept/notifyFlagged`]: this.state.notifyFlagged,
        }, () => {

            this.props.acceptRequest(this.props.project.id);
        });

    };

    onRegenerateWebhookCredentials = e => {

        e.preventDefault();

        return api.regenerateWebhookCredentials({ projectId: this.props.project.id })
            .then(({ data: project }) => {

                this.props.changeProjects(projects => {

                    return projects.map(p => {

                        if (p.id === project.id) {
                            return project;
                        }
                        return p;
                    });
                });
            });
    };

    onRegenerateSingleSignOnCredentials = e => {

        e.preventDefault();

        return api.regenerateSingleSignOnCredentials({ projectId: this.props.project.id })
            .then(({ data: project }) => {

                this.props.changeProjects(projects => {

                    return projects.map(p => {

                        if (p.id === project.id) {
                            return project;
                        }
                        return p;
                    });
                });
            });
    };

    errorFor(field, id) {

        if (!this.state.errors || !this.state.errors[field]) {
            return null;
        }

        return (
            <label htmlFor={id || null} className="error">{this.state.errors[field]}</label>
        );
    }

    get pricingPlan() {

        const [ source ] = this.props.stripeCustomer.sources.data;
        const Overlay = !source ? OverlayTrigger : FakeOverlay;
        let monthlySelected = false;
        let yearlySelected = false;

        switch (this.state.professionalPlan) {
            case 'professional-monthly':
                monthlySelected = true;
                break;
            case 'professional-yearly':
                yearlySelected = true;
                break;
            default:
                monthlySelected = this.state.pricingPlan === 'professional-monthly';
                yearlySelected = this.state.pricingPlan === 'professional-yearly';
                break;
        }
        if (!monthlySelected && !yearlySelected) {
            monthlySelected = true;
        }

        return (
            <div className="plans">

                <div className="row">

                    <div className="col-lg-6 col-md-6">

                        <div className={classNames('panel panel-default panel-radio', { selected: this.state.pricingPlan === 'personal' })}>

                            <div className="panel-heading">
                                <div className="radio">

                                    <label>
                                        <strong>
                                            <input
                                                type="radio"
                                                name="pricing-plan"
                                                value="personal"
                                                onChange={this.onChangePricingPlan}
                                                checked={this.state.pricingPlan === 'personal'}
                                            />
                                            Personal
                                        </strong>
                                    </label>

                                </div>
                            </div>
                            <div className="panel-body">

                                <h3>
                                    Free
                                </h3>

                                <div className="sub">
                                    <span className="label label-default">
                                        Within comment limit
                                    </span>
                                </div>

                                <ul>
                                    <li>
                                        100 comments / month
                                    </li>
                                    <li>
                                        Unlimited page views
                                    </li>
                                    <li>
                                        Basic moderation tools
                                    </li>
                                    <li>
                                        $15 if over comment limit
                                    </li>
                                    <li>
                                        No credit card required at sign-up
                                    </li>
                                </ul>

                            </div>
                        </div>

                    </div>

                    <div className="col-lg-6 col-md-6">

                        <div className={classNames('panel panel-default panel-radio', { selected: this.state.pricingPlan.indexOf('professional-') !== -1 })}>

                            <div className="panel-heading">
                                <div className={classNames('radio', { disabled: !source })}>

                                    <Overlay placement="top" overlay={paymentTooltip}>

                                        <label>
                                            <strong>
                                                <input
                                                    type="radio"
                                                    name="pricing-plan"
                                                    value="professional"
                                                    onChange={this.onChangePricingPlan}
                                                    checked={this.state.pricingPlan.indexOf('professional-') !== -1}
                                                    disabled={!source}
                                                />
                                                Professional
                                            </strong>
                                        </label>

                                    </Overlay>

                                </div>
                            </div>
                            <div className="panel-body">

                                <h3>
                                    {yearlySelected ? '$100 / year' : '$10 / month'}
                                </h3>

                                <div className="sub">

                                    <div className="btn-group btn-group-justified" role="group">
                                        <div className="btn-group" role="group">
                                            <button
                                                type="button"
                                                className={classNames('btn btn-xs', monthlySelected ? 'btn-success' : 'btn-default'  )}
                                                value="professional-monthly"
                                                onClick={this.onChangeProfessionalPlan}
                                            >
                                                Monthly
                                            </button>
                                        </div>
                                        <div className="btn-group" role="group">
                                            <button
                                                type="button"
                                                className={classNames('btn btn-xs', yearlySelected ? 'btn-success' : 'btn-default'  )}
                                                value="professional-yearly"
                                                onClick={this.onChangeProfessionalPlan}
                                            >
                                                Yearly
                                            </button>
                                        </div>
                                    </div>

                                </div>

                                <ul>
                                    <li>
                                        Unlimited comments
                                    </li>
                                    <li>
                                        Unlimited page views
                                    </li>
                                    <li>
                                        Basic moderation tools
                                    </li>
                                    <li>
                                        Webhook support
                                    </li>
                                    <li>
                                        Slack notifications
                                    </li>
                                    <li>
                                        Single sign-on
                                    </li>
                                    <li>
                                        2 months free with yearly plan
                                    </li>
                                </ul>

                            </div>
                        </div>

                    </div>

                </div>

                <div className="row">

                    <div className="col-lg-12">

                        <fieldset>

                            <legend>
                                Optional Add-ons
                            </legend>

                            <div className="row">

                                <div className="col-lg-6 col-md-6">

                                    <div className={classNames('panel panel-default panel-radio', { selected: this.state.moderationPlus })}>

                                        <div className="panel-heading">
                                            <div className={classNames('checkbox', { disabled: !source })}>


                                                <Overlay placement="top" overlay={paymentTooltip}>

                                                    <label>
                                                        <strong>
                                                            <input
                                                                type="checkbox"
                                                                value=""
                                                                onChange={this.onChangeModerationPlus}
                                                                checked={this.state.moderationPlus}
                                                                disabled={!source}
                                                            />
                                                            Moderation Plus
                                                        </strong>
                                                    </label>

                                                </Overlay>

                                            </div>
                                        </div>
                                        <div className="panel-body">

                                            <h3>
                                                $20 / month
                                            </h3>

                                            <div className="sub">
                                                <span className="label label-default">
                                                    Per 5K comments
                                                </span>
                                            </div>

                                            <ul>
                                                <li>
                                                    Granular moderation filters
                                                </li>
                                                <li>
                                                    "Shadow ban" users
                                                </li>
                                                <li>
                                                    Lock and disable threads
                                                </li>
                                                <li>
                                                    Search and filtering capability
                                                </li>
                                                <li>
                                                    Up to nine extra moderators
                                                </li>
                                            </ul>

                                        </div>
                                    </div>

                                </div>

                            </div>

                        </fieldset>

                    </div>

                </div>

            </div>
        );

    }

    get moderatorEmails() {

        const extraEmails = !this.state.moderationPlus ? [] : this.state.moderatorEmails;
        const Overlay = !this.state.moderationPlus ? OverlayTrigger : FakeOverlay;


        return [this.props.user.email].concat(extraEmails).map((email, index) => (
            <li key={index}>

                <Overlay placement="top" overlay={granularTooltip}>

                    <div className="input-group">
                        <input
                            type="email"
                            className="form-control"
                            name="moderator-emails"
                            placeholder="jane@example.com"
                            value={email}
                            onChange={this.onChangeModeratorEmailFactory(index - 1)}
                            readOnly={index === 0}
                        />

                        <div className="input-group-btn">

                            <button
                                type="button"
                                className="btn"
                                value={index - 1}
                                onClick={this.onRemoveModeratorEmail}
                                disabled={index === 0}

                            >
                                <span className="glyphicon glyphicon-minus" />
                            </button>
                            <button
                                type="button"
                                className="btn"
                                onClick={this.onAddModeratorEmail}
                                disabled={index === 10 || !this.state.moderationPlus}
                            >
                                <span className="glyphicon glyphicon-plus" />
                            </button>

                        </div>

                    </div>

                </Overlay>

            </li>
        ));
    }

    get approvalProcess() {

        return this.props.approvalProcessOptions.map(({ value, title, desc }) => {

            const disabled = !this.state.moderationPlus && value === 'granular';
            const Overlay = disabled ? OverlayTrigger : FakeOverlay;

            return (
                <div id={`plan-${value}`} className="col-lg-8 col-lg-offset-2 col-md-8 col-md-offset-2" key={value}>

                    <div className={classNames('panel panel-default panel-radio', { selected: this.state.approvalProcess === value })}>

                        <div className="panel-heading">
                            <div className={classNames('radio', { disabled })}>

                                <Overlay placement="top" overlay={granularTooltip}>

                                    <label>
                                        <strong>
                                            <input
                                                type="radio"
                                                name="approval-process-high-level"
                                                value={value}
                                                onChange={this.onChangeApprovalProcess}
                                                checked={this.state.approvalProcess === value}
                                                disabled={disabled}
                                            />
                                            {title}
                                        </strong>
                                        { value === 'granular' ? (
                                            <span className="label label-default">moderation plus</span>
                                        ) : null }
                                    </label>

                                </Overlay>
                            </div>
                        </div>
                        <div className="panel-body">

                            {desc}
                            {value === 'granular' ? (
                                <ul className="approval-process-lower-level">
                                    {this.approvalProcessGranular}
                                </ul>
                            ) : null}

                        </div>
                    </div>

                </div>
            );
        });
    }

    get approvalProcessGranular() {

        return this.props.approvalProcessGranularOptions.map(({ value, desc }) => {

            const disabled = !this.state.moderationPlus;
            const Overlay = disabled ? OverlayTrigger : FakeOverlay;

            return (
                <li key={value}>
                    <div className={classNames('checkbox', { disabled })}>

                        <Overlay placement="right" overlay={granularTooltip}>

                            <label>
                                <input
                                    type="checkbox"
                                    name="approval-process-low-level"
                                    value={value}
                                    checked={this.state.approvalProcessGranular.indexOf(value) !== -1}
                                    onChange={this.onChangeApprovalProcessGranular}
                                    disabled={disabled}
                                />
                                {desc}
                            </label>

                        </Overlay>

                    </div>
                </li>
            );

        });
    }

    get webhookCredentials() {

        const body = this.props.project.id ? (
            <form onSubmit={this.onRegenerateWebhookCredentials}>
                <p className="text-muted">
                    We will send these credentials as <strong>Basic Authentication</strong> headers to your webhook URL.
                </p>
                <div className="form-group">
                    <label htmlFor="project-id">Username</label>
                    <input
                        type="text"
                        className="form-control"
                        id="project-id"
                        value={this.props.project.id}
                        readOnly={true}
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="webhook-secret">Password</label>
                    <input
                        type="text"
                        className="form-control"
                        id="webhook-secret"
                        value={this.props.project.webhookSecret}
                        readOnly={true}
                        placeholder="No secret found. Please generate new credentials."
                    />
                </div>
                <div className="form-group clearfix">
                    <button type="submit" className="btn btn-danger pull-right">
                        Generate New Credentials
                    </button>
                </div>
            </form>
        ) : (
            <div>
                <div className="well">
                    Credentials may be generated after you save the project.
                </div>
            </div>
        );

        return (
            <Modal show={this.state.webhookCredentialsAreShowing}>

                <Modal.Header closeButton onHide={this.onToggleWebhookCredentials}>
                    <Modal.Title>Webhook Credentials</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {body}
                </Modal.Body>
            </Modal>
        );
    }

    get singleSignOnCredentials() {

        const body = this.props.project.id ? (
            <form onSubmit={this.onRegenerateSingleSignOnCredentials}>
                <p className="text-muted">
                    Use the secret below to sign your JWT.
                </p>
                <div className="form-group">
                    <label htmlFor="sso-secret">Secret</label>
                    <input
                        type="text"
                        className="form-control"
                        id="sso-secret"
                        value={this.props.project.ssoSecret}
                        readOnly={true}
                        placeholder="No secret found. Please generate new credentials."
                    />
                </div>
                <div className="form-group clearfix">
                    <button type="submit" className="btn btn-danger pull-right">
                        Generate New Credentials
                    </button>
                </div>
            </form>
        ) : (
            <div>
                <div className="well">
                    Credentials may be generated after you save the project.
                </div>
            </div>
        );

        return (
            <Modal show={this.state.singleSignOnCredentialsAreShowing}>

                <Modal.Header closeButton onHide={this.onToggleSingleSignOnCredentials}>
                    <Modal.Title>Single Sign-On Credentials</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {body}
                </Modal.Body>
            </Modal>
        );
    }

    get confirmation() {

        const body = this.props.project.id ? (
            <div style={{textAlign: 'center'}}>
                <p>
                    Project saved!
                </p>
            </div>
        ) : (
            <div>
                <p>
                    Project created! You may now embed CommentBox into your site.
                </p>
                <div className="form-group">
                    <label htmlFor={"project-id"}>Project ID</label>
                    <input id="project-id" className="form-control" type="text" value={this.state.id} readOnly={true} />
                </div>
                <p style={{textAlign: 'center'}}>
                    <a className="btn btn-default" target="_blank" href="https://commentbox.io/docs">Embed Instructions</a>
                </p>
            </div>
        );

        return (
            <Modal show={this.state.confirmationIsShowing}>

                <Modal.Header closeButton onHide={this.onHideConfirmation}>
                    <Modal.Title>Success</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {body}
                </Modal.Body>
            </Modal>
        );
    }

    get deleteProject() {

        return (
            <Modal show={this.state.deleteProjectIsShowing}>

                <Modal.Header closeButton onHide={this.onHideDeleteProject}>
                    <Modal.Title>Danger Zone</Modal.Title>
                </Modal.Header>

                <Modal.Body>

                    <DeleteEverything
                        onSubmit={this.onDeleteProject}
                        changeCover={this.props.changeCover}
                        label="Project Removal"
                    >
                        Warning: all your data (including comments, votes, etc.) will be deleted. This action is <strong>irreversible</strong>.
                    </DeleteEverything>

                </Modal.Body>
            </Modal>
        );
    }

    get downgrade() {

        return (
            <Modal show={!!this.state.downgradeIsShowing}>

                <Modal.Header>
                    <Modal.Title>Downgrade Warning</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <p>
                        Are you sure you wish to remove the Moderation Plus Add-on? Your comments will no longer be indexed
                        for searching and filtering, and you will lose any extra moderators you've invited.
                    </p>

                    <div className="row">

                        <div
                            className="col-lg-4 col-lg-offset-2 col-md-4 col-md-offset-2 col-sm-4 col-sm-offset-2"
                            style={{ textAlign: 'right' }}
                        >

                            <div className="form-group">

                                <button
                                    className="btn btn-success btn-block"
                                    value="reject"
                                    onClick={this.onHideDowngrade}
                                >
                                    I've changed my mind
                                </button>

                            </div>


                        </div>

                        <div className="col-lg-4 col-md-4 col-sm-4">

                            <div className="form-group">

                                <button
                                    className="btn btn-danger btn-block"
                                    value="resolve"
                                    onClick={this.onHideDowngrade}
                                >
                                    Yes I'm sure
                                </button>

                            </div>

                        </div>

                    </div>

                </Modal.Body>
            </Modal>
        );
    }

    get paymentMethod() {

        return (
            <BillingInfoModal
                stripeCustomer={this.props.stripeCustomer}
                show={this.state.showPaymentMethod}
                hide={this.onTogglePaymentMethodModal}
                changeCover={this.props.changeCover}
                changeStripeCustomer={this.props.changeStripeCustomer}
            />
        );
    }

    get moderatorPage() {

        return (
            <div className="setup">

                <form>

                    <div id="moderation" className="panel panel-default top-level">

                        <div className="panel-body">

                            <fieldset>
                                <legend>Moderation</legend>

                                <div className="row">

                                    <div className="col-lg-8 col-lg-offset-2 col-md-8 col-md-offset-2">

                                        <div className="form-group">

                                            <label>Settings</label>

                                            <div className="checkbox">
                                                <label>
                                                    <input
                                                        type="checkbox"
                                                        value="notifyApproved"
                                                        checked={this.state.notifyApproved}
                                                        onChange={this.onChangeNotify}
                                                    />
                                                    Notify me of new automatically approved comments
                                                </label>
                                            </div>


                                            <div className="checkbox">
                                                <label>
                                                    <input
                                                        type="checkbox"
                                                        value="notifyPending"
                                                        checked={this.state.notifyPending}
                                                        onChange={this.onChangeNotify}
                                                    />
                                                    Notify me of new comments pending moderation
                                                </label>
                                            </div>

                                            <div className="checkbox">
                                                <label>
                                                    <input
                                                        type="checkbox"
                                                        value="notifyFlagged"
                                                        checked={this.state.notifyFlagged}
                                                        onChange={this.onChangeNotify}
                                                    />
                                                    Notify me of flagged comments
                                                </label>
                                            </div>

                                        </div>

                                        <div className="row">

                                            <div className="col-sm-6 col-xs-12">

                                                <div className="form-group">

                                                    <button
                                                        className="btn btn-danger btn-block"
                                                        type="button"
                                                        value={this.props.project.id}
                                                        onClick={this.props.onRejectRequest}
                                                    >
                                                        Leave Project
                                                    </button>

                                                </div>

                                            </div>


                                            <div className="col-sm-6 col-xs-12">

                                                <div className="form-group">

                                                    <button
                                                        className="btn btn-success btn-block"
                                                        type="button"
                                                        value={this.props.project.id}
                                                        onClick={this.onUpdateModeratorSettings}
                                                    >
                                                        Update Settings
                                                    </button>

                                                </div>

                                            </div>

                                        </div>


                                    </div>

                                </div>
                            </fieldset>

                        </div>
                    </div>

                </form>

            </div>
        );
    }

    render() {

        if (this.props.project.id && this.props.project.userId !== this.props.user.uid) {

            return this.moderatorPage;
        }


        const [ source ] = this.props.stripeCustomer.sources.data;
        const update = source ? `Using ${source.card.brand} ending in ${source.card.last4}` : 'Setup billing info';
        const Overlay = this.props.user.emailVerified ? FakeOverlay : OverlayTrigger;

        const ProOverlay = this.state.pricingPlan === 'personal' ? OverlayTrigger : FakeOverlay;

        return (
            <div className="setup">

                {this.paymentMethod}
                {this.webhookCredentials}
                {this.singleSignOnCredentials}
                {this.confirmation}
                {this.deleteProject}
                {this.downgrade}

                <form onSubmit={this.onSubmit}>

                    <div id="basic-info" className="panel panel-default top-level">

                        <div className="panel-body">

                            <fieldset>
                                <legend>Basic Info</legend>

                                <div className="row">

                                    <div className="col-lg-8 col-lg-offset-2 col-md-8 col-md-offset-2">

                                        {this.state.id ? (
                                            <div className="form-group">
                                                <label htmlFor="id">Project ID</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="id"
                                                    value={this.state.id}
                                                    readOnly={true}
                                                />
                                            </div>
                                        ) : null}

                                        <div className="form-group">
                                            <label htmlFor="name">Website Name</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="name"
                                                placeholder="My Awesome Blog"
                                                value={this.state.name}
                                                onChange={this.onChangeName}
                                                required
                                            />
                                            {this.errorFor('name', 'name')}
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="domain">Website Domain</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="domain"
                                                placeholder="example.com"
                                                value={this.state.domain}
                                                onChange={this.onChangeDomain}
                                                onBlur={this.onBlurDomain}
                                                required
                                            />
                                            {this.errorFor('domain', 'domain')}
                                        </div>

                                        <div className="form-group">
                                            <label>
                                                Email Settings
                                            </label>

                                            <div className="checkbox" style={{marginTop: 0}}>
                                                <label>
                                                    <input
                                                        type="checkbox"
                                                        value="notifyApproved"
                                                        checked={this.state.notifyApproved}
                                                        onChange={this.onChangeNotify}
                                                    />
                                                        Notify me of new automatically approved comments
                                                </label>
                                            </div>

                                            <div className="checkbox">
                                                <label>
                                                    <input
                                                        type="checkbox"
                                                        value="notifyPending"
                                                        checked={this.state.notifyPending}
                                                        onChange={this.onChangeNotify}
                                                    />
                                                    Notify me of new comments pending moderation
                                                </label>
                                            </div>

                                            <div className="checkbox">
                                                <label>
                                                    <input
                                                        type="checkbox"
                                                        value="notifyFlagged"
                                                        checked={this.state.notifyFlagged}
                                                        onChange={this.onChangeNotify}
                                                    />
                                                    Notify me of flagged comments
                                                </label>
                                            </div>

                                        </div>

                                        <div className="form-group">
                                            <label htmlFor="flag-threshold">
                                                How many users must flag a comment to notify you?
                                            </label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                id="flag-threshold"
                                                value={this.state.flagThreshold}
                                                onChange={this.onChangeFlagThreshold}
                                                placeholder="0"
                                                step="1"
                                                min={0}
                                                max={999}
                                                required
                                            />
                                            {this.errorFor('flagThreshold', 'flag-threshold')}
                                        </div>

                                    </div>

                                </div>
                            </fieldset>

                        </div>
                    </div>

                    <div className="separator">

                        {this.props.scrollTo('pricing-plan')}

                    </div>

                    <div id="pricing-plan" className="panel panel-default top-level">

                        <div className="panel-body">

                            <fieldset>
                                <legend>
                                    Pricing Plan <a target="_blank" href="https://commentbox.io/docs/dashboard#pricing">Learn more <span className="glyphicon glyphicon-share-alt" /></a>
                                </legend>

                                <div className="form-group">

                                    <div className="clearfix" style={{ paddingTop: 5, paddingBottom: 15 }}>
                                        <button
                                            type="button"
                                            className="btn btn-default pull-right"
                                            onClick={this.onTogglePaymentMethodModal}
                                        >
                                            {update}
                                        </button>
                                    </div>

                                    {this.pricingPlan}
                                </div>

                            </fieldset>


                        </div>
                    </div>


                    <div className="separator">

                        {this.props.scrollTo('moderation-rules')}

                    </div>

                    <div id="moderation-rules" className="panel panel-default top-level">

                        <div className="panel-body">

                            <fieldset>
                                <legend>
                                    Moderation Rules <a target="_blank" href="https://commentbox.io/docs/dashboard#moderation-rules">Learn more <span className="glyphicon glyphicon-share-alt" /></a>
                                </legend>

                                <div className="form-group">

                                    <div className="row">

                                        {this.approvalProcess}

                                    </div>
                                </div>

                            </fieldset>

                        </div>
                    </div>


                    <div className="separator">

                        {this.props.scrollTo('extra-moderators')}

                    </div>

                    <div id="extra-moderators" className="panel panel-default top-level">

                        <div className="panel-body">

                            <fieldset>
                                <legend>
                                    Extra Moderators <small>(optional)</small> <span className="label label-default">moderation plus</span> <a target="_blank" href="https://commentbox.io/docs/dashboard#extra-moderators">Learn more <span className="glyphicon glyphicon-share-alt" /></a>
                                </legend>


                                <p className="text-muted">
                                    Any new moderators you enter won't get an email (to prevent spam), but they will get a notification the next time they sign in to the dashboard.
                                </p>

                                <div className="row">

                                    <div className="col-lg-8 col-lg-offset-2 col-md-8 col-md-offset-2">

                                        <div className="form-group">
                                            <label htmlFor="moderator-emails">Add moderator email addresses:</label>

                                            <ul>
                                                {this.moderatorEmails}
                                            </ul>
                                            {this.errorFor('moderatorEmails', 'moderator-emails')}

                                        </div>

                                    </div>

                                </div>

                            </fieldset>

                        </div>
                    </div>

                    <div className="separator">

                        {this.props.scrollTo('webhooks')}

                    </div>

                    <div id="webhooks" className="panel panel-default top-level">

                        <div className="panel-body">

                            <fieldset>
                                <legend>
                                    Webhooks <small>(optional)</small> <span className="label label-default">professional</span> <a target="_blank" href="https://commentbox.io/docs/dashboard#webhooks">Learn more <span className="glyphicon glyphicon-share-alt" /></a>
                                </legend>


                                <div className="form-group">
                                    <label htmlFor="slack-url">Slack webhook URL <small>- fires only for the events below</small></label>

                                    <ProOverlay placement="top" overlay={proTooltip}>

                                        <input
                                            type="url"
                                            className="form-control"
                                            id="slack-url"
                                            placeholder="https://hooks.slack.com/services/..."
                                            value={this.state.slackUrl}
                                            onChange={this.onChangeSlackUrl}
                                            disabled={this.state.pricingPlan === 'personal'}
                                        />

                                    </ProOverlay>

                                    {this.errorFor('slackUrl', 'slack-url')}

                                    <div className={classNames('checkbox', { disabled: this.state.pricingPlan === 'personal' })}>

                                        <ProOverlay placement="right" overlay={proTooltip}>

                                            <label>
                                                <input
                                                    type="checkbox"
                                                    value="slackNotifyApproved"
                                                    checked={this.state.slackNotifyApproved}
                                                    onChange={this.onChangeNotify}
                                                    disabled={this.state.pricingPlan === 'personal'}
                                                />
                                                Notify Slack of new automatically approved comments
                                            </label>

                                        </ProOverlay>

                                    </div>

                                    <div className={classNames('checkbox', { disabled: this.state.pricingPlan === 'personal' })}>

                                        <ProOverlay placement="right" overlay={proTooltip}>

                                            <label>
                                                <input
                                                    type="checkbox"
                                                    value="slackNotifyPending"
                                                    checked={this.state.slackNotifyPending}
                                                    onChange={this.onChangeNotify}
                                                    disabled={this.state.pricingPlan === 'personal'}
                                                />
                                                Notify Slack of new comments pending moderation
                                            </label>

                                        </ProOverlay>

                                    </div>

                                    <div className={classNames('checkbox', { disabled: this.state.pricingPlan === 'personal' })}>

                                        <ProOverlay placement="right" overlay={proTooltip}>

                                            <label>
                                                <input
                                                    type="checkbox"
                                                    value="slackNotifyFlagged"
                                                    checked={this.state.slackNotifyFlagged}
                                                    onChange={this.onChangeNotify}
                                                    disabled={this.state.pricingPlan === 'personal'}
                                                />
                                                Notify Slack of flagged comments
                                            </label>

                                        </ProOverlay>

                                    </div>

                                </div>

                                <hr />

                                <div className="form-group">
                                    <label htmlFor="webhook">Webhook URL <small>- fires for every event</small></label>

                                    <ProOverlay placement="top" overlay={proTooltip}>

                                        <input
                                            type="url"
                                            className="form-control"
                                            id="webhook"
                                            placeholder="https://example.com/events/..."
                                            value={this.state.webhook}
                                            onChange={this.onChangeWebhook}
                                            disabled={this.state.pricingPlan === 'personal'}
                                        />

                                    </ProOverlay>

                                    {this.errorFor('webhook', 'webhook')}
                                </div>

                                <div className="clearfix">

                                    <ProOverlay placement="top" overlay={proTooltip}>

                                        <button
                                            type="button"
                                            className="btn btn-default pull-right"
                                            onClick={this.onToggleWebhookCredentials}
                                            disabled={this.state.pricingPlan === 'personal'}
                                        >
                                            Show webhook credentials
                                        </button>

                                    </ProOverlay>

                                </div>

                            </fieldset>

                        </div>
                    </div>

                    <div className="separator">

                        {this.props.scrollTo('single-sign-on')}

                    </div>

                    <div id="single-sign-on" className="panel panel-default top-level">

                        <div className="panel-body">

                            <fieldset>
                                <legend>
                                    Single Sign-On <small>(optional)</small> <span className="label label-default">professional</span> <a target="_blank" href="https://commentbox.io/docs#single-sign-on">Learn more <span className="glyphicon glyphicon-share-alt" /></a>
                                </legend>

                                <div className="well">
                                    Single Sign-On lets your users sign in using your site's own native authentication system. It's flexible and powerful enough to automatically utilize existing user sessions, creating a zero-friction method for your existing users to leave comments.
                                </div>

                                <div className="clearfix">

                                    <ProOverlay placement="top" overlay={proTooltip}>

                                        <button
                                            type="button"
                                            className="btn btn-default pull-right"
                                            onClick={this.onToggleSingleSignOnCredentials}
                                            disabled={this.state.pricingPlan === 'personal'}
                                        >
                                            Show Single Sign-On credentials
                                        </button>

                                    </ProOverlay>

                                </div>

                            </fieldset>

                        </div>
                    </div>

                    <div className="separator">

                        <span className="glyphicon glyphicon-chevron-down" aria-hidden="true"/>

                    </div>


                    <div id="save-project" className="row">

                        <div className="col-lg-6 col-lg-offset-3 col-md-6 col-md-offset-3 col-sm-8 col-sm-offset-2">

                            <div className="form-group">

                                <Overlay placement="bottom" overlay={verifiedTooltip}>

                                    <button
                                        type="submit"
                                        className="btn btn-success btn-lg btn-block"
                                        disabled={!this.props.user.emailVerified}
                                    >
                                        {this.props.project.id ? 'Update' : 'Create'} Project
                                    </button>

                                </Overlay>

                            </div>
                            <div className={classNames('form-group text-center danger', { hidden: !this.props.project.id })}>

                                <hr />

                                <button className="btn btn-link" type="button" onClick={this.onShowDeleteProject}>
                                    Delete Project
                                </button>
                            </div>

                        </div>

                    </div>

                </form>

            </div>
        );

    }
}

export default Setup;



// WEBPACK FOOTER //
// ./src/components/projects/Setup.jsx